"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const piral_core_1 = require("piral-core");
const components_1 = require("@smapiot/components");
const HomePage = React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/Home'))));
const LogoutPage = React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/Logout'))));
const UserApp = ({ instance }) => (React.createElement(piral_core_1.Piral, { instance: instance },
    React.createElement(piral_core_1.SetRoute, { path: "/", component: HomePage }),
    React.createElement(piral_core_1.SetRoute, { path: "/logout", component: LogoutPage }),
    React.createElement(react_router_dom_1.Route, { component: components_1.ScrollToTop })));
exports.default = UserApp;
